// packages/agent-kit/src/hooks/admin/useUsersList.ts
import useSWR from 'swr';
import { adminUserService, isApiError } from '@dopomogai/api-client';
import type { UserListFilters } from '@dopomogai/api-client';
import type { UserDB } from '@dopomogai/types';
import { AgentKitError } from '../../types';

export const useUsersList = (filters: UserListFilters = {}) => {
  const swrKey = ['/admin/users', filters];

  const { data, error, isLoading, mutate } = useSWR<UserDB[], AgentKitError>(
    swrKey,
    async ([, currentFilters]: [string, UserListFilters]) => {
      const response = await adminUserService.listAllUsers(currentFilters);
      if (isApiError(response)) {
        throw new AgentKitError('Failed to fetch user list', response);
      }
      return response;
    },
    // --- THIS IS THE FIX ---
    {
      revalidateOnFocus: false,    // **CRITICAL**: Stops refetching on window focus.
      keepPreviousData: true,      // Keeps old data visible during reloads (e.g., filter changes).
      dedupingInterval: 10000,     // Prevents rapid-fire requests.
    }
  );

  return { 
    users: data, 
    error, 
    isLoading, 
    mutate 
  };
};